import React, { useEffect, useRef } from 'react';
import { MessageBubble } from './MessageBubble';
import { Avatar } from '../ui/Avatar';
interface Message {
  id: string;
  content: string;
  timestamp: string;
  isSent: boolean;
  status?: 'sent' | 'delivered' | 'read';
}
interface MessageListProps {
  messages: Message[];
  otherUserAvatar: string;
  isTyping?: boolean;
}
export function MessageList({
  messages,
  otherUserAvatar,
  isTyping
}: MessageListProps) {
  const bottomRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    bottomRef.current?.scrollIntoView({
      behavior: 'smooth'
    });
  }, [messages, isTyping]);
  return <div className="flex-1 overflow-y-auto p-4 bg-gray-50" data-id="element-131">
      {/* Date Separator Example */}
      <div className="flex justify-center mb-6" data-id="element-132">
        <span className="text-xs font-medium text-gray-400 bg-gray-100 px-3 py-1 rounded-full" data-id="element-133">
          Today
        </span>
      </div>

      {messages.map(msg => <div key={msg.id} className={`flex ${msg.isSent ? 'justify-end' : 'justify-start'} mb-2`} data-id="element-134">
          {!msg.isSent && <Avatar src={otherUserAvatar} alt="User" size="sm" className="mr-2 mt-1" data-id="element-135" />}
          <MessageBubble content={msg.content} timestamp={msg.timestamp} isSent={msg.isSent} status={msg.status} data-id="element-136" />
        </div>)}

      {isTyping && <div className="flex justify-start mb-4" data-id="element-137">
          <Avatar src={otherUserAvatar} alt="User" size="sm" className="mr-2 mt-1" data-id="element-138" />
          <div className="bg-white border border-gray-100 px-4 py-3 rounded-2xl rounded-bl-none shadow-sm" data-id="element-139">
            <div className="flex space-x-1" data-id="element-140">
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{
            animationDelay: '0ms'
          }} data-id="element-141" />
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{
            animationDelay: '150ms'
          }} data-id="element-142" />
              <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{
            animationDelay: '300ms'
          }} data-id="element-143" />
            </div>
          </div>
        </div>}

      <div ref={bottomRef} data-id="element-144" />
    </div>;
}